import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import * as styles from './index.css'
import { BLUELEAF_LOGO_WHITE } from '../SharedConstants/Images'

export default function AdvisorGenericLogin ({ authenticate, advisor }) {
  const year = new Date().getFullYear()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    authenticate(email, password)
  }

  const getPracticeName = () => {
    if (!advisor.logo_contains_firm_name) {
      return <div className={styles.practiceName}>
        {advisor.practice_name || advisor.email}
      </div>
    }
  }

  const getWrapperColor = () => {
    if (advisor.branding_color === 'blue') {
      return styles.wrapperBlue
    } else if (advisor.branding_color === 'pink') {
      return styles.wrapperPink
    } else if (advisor.branding_color === 'green') {
      return styles.wrapperGreen
    }
  }

  return (
    <div className={`${styles.wrapper}, ${getWrapperColor()}`}>
      <div className={styles.decorativeCircleTop}></div>
      <div className={styles.decorativeCircleBottom}></div>

      <div className={styles.header}>
        <div className={styles.headerTop}>
          <img
            alt="Firm Logo"
            src={advisor.logo_url}
            className={styles.advisorPhoto}
          />
          { getPracticeName() }
        </div>
        <div className={styles.dividerLine}></div>
        <div className={styles.advisorName}>
          {advisor.advisor_name}
        </div>
      </div>

      <div className={styles.mainContent}>
        <div className={styles.formWrapper}>
          <div className={styles.formCard}>
            <div className={styles.formHeader}>
              <h2 className={styles.title}>Sign In</h2>
              <p className={styles.subtitle}>Welcome back!</p>
            </div>
            <form id="generic-login-form" onSubmit={handleSubmit}>
              <div className={styles.fieldGroup}>
                <label className={styles.label}>Email Address</label>
                <input
                  className={styles.input}
                  placeholder="you@example.com"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className={styles.fieldGroup}>
                <label className={styles.label}>Password</label>
                <input
                  className={styles.input}
                  placeholder="Enter your password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className={styles.forgotPasswordContainer}>
                <Link className={styles.forgotPasswordLink} to="/forgot_password">
                  Forgot your password?
                </Link>
              </div>
              <button
                type="submit"
                className={styles.submitButton}
              >
                Sign In
              </button>
            </form>
          </div>
          <div className={styles.supportContainer}>
            <span className={styles.supportText}>
              Need help? <a href="mailto:vipsupport@blueleaf.com" className={styles.supportLink}>
                Contact support
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <div className={styles.logoContainer}>
          <img
            alt="Blueleaf"
            src={BLUELEAF_LOGO_WHITE}
            className={styles.logo}
          />
        </div>
        <div className={styles.footerContent}>
          <p className={styles.footerText}>
            <strong className={styles.footerDisclaimer}>Advisor Disclaimer:</strong>
            <br /><br />
            {advisor.subdomain}.blueleaf.com is provided by your financial advisor through Blueleaf. © {year} Blueleaf Wealth, Inc. All rights reserved.
            <br />
            {advisor.disclaimer && (
              <>
                <br />
                {advisor.disclaimer}
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}
